import { render, staticRenderFns } from "./TxCkeEditor.vue?vue&type=template&id=627c6b42&scoped=true&"
import script from "./TxCkeEditor.vue?vue&type=script&lang=js&"
export * from "./TxCkeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627c6b42",
  null
  
)

export default component.exports